import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pwa from './en-US/pwa';
import common from './en-US/common';
import form from './en-US/form';
import supportChat from './en-US/supportChat';
import builderChat from './en-US/builderChat';
import notifications from './en-US/notifications';
import processes from '../pages/Process/locales/en-US';
import launchpad from '../pages/Launchpad/locales/en-US';
import apps from '../pages/apps/locales/en-US';
import home from '../pages/Home/locales/en-US';
import applicationsModern from '../pages/applications-modern/locales/en-US';
import documents from '../pages/documents/locales/en-US';
import tasks from '../pages/tasks/locales/en-US';
import tasksModern from '../pages/tasks-modern/locales/en-US';
import channelOnboarding from '../pages/configurations/channel-onboarding/locales/en-US';
import whiteLabel from '../pages/configurations/white-label/locales/en-US';
import aiAgentSchedule from '../pages/administration-agents/ai-agent-work/locales/en-US';
import rpaAgents from '../pages/administration-agents/rpa-agents/locales/en-US';
import usage from '../pages/configurations/usage/locales/en-US';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page for your local project',
  'app.welcome.link.fetch-blocks': 'Get all blocks',
  'app.welcome.link.block-list': 'Quickly build standard pages based on block development',
  ...globalHeader,
  ...menu,
  ...pwa,
  ...component,
  ...common,
  ...form,
  ...supportChat,
  ...builderChat,
  ...notifications,
  ...processes,
  ...launchpad,
  ...apps,
  ...home,
  ...applicationsModern,
  ...documents,
  ...tasks,
  ...tasksModern,
  ...channelOnboarding,
  ...whiteLabel,
  ...aiAgentSchedule,
  ...rpaAgents,
  ...usage,
};
